import Divider from '@mui/material/Divider';

export default Divider;